import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "menu" }

import { computed, watch } from "vue";
import { IMainNavGroup } from "./Navigation-types";
import { UseProgramStore } from "../Modules/State/Stores/ProgramStore";
import { UseMainStore } from "../Modules/State/SingleViewStorePinia";
import { storeToRefs } from "pinia";
import MainNavigationList from "./MainNavigationList.vue";
import UseMainNavigation from "./UseMainNavigation";
import { useRouter } from "vue-router";
//From Stores

export default /*#__PURE__*/_defineComponent({
  props: {
    close: null
  },
  setup(__props: any) {

const props = __props as {
  close(): void;
}

const programStore = UseProgramStore();
const {
  getCurrentProgram,
  getCurrentProgramName,
  getCurrentProgramCustomReports,
  getAvailablePrograms,
} = storeToRefs(programStore);
const { setProgram } = programStore;
const { getUserAdmin } = storeToRefs(UseMainStore());
//From Hooks
const { activeProgram } = UseMainNavigation();
//Props


//Navigation Items
const menuItems = computed((): IMainNavGroup[] => [
  {
    title: "Reports",
    navItems: [
      {
        to: "/performance",
        label: "Performance",
      },
      {
        to: "/breakdown",
        label: "Channel Breakdown",
      },
      {
        to: "/attribution-comparison",
        label: "Attribution Comparison",
      },
      {
        to: "/funnel",
        label: "Funnel Report",
        config: {
          hasTag: true,
          tagText: "Updated",
        },
      },
      {
        to: "/funnel-trends",
        label: "Funnel Trends Over Time",
        config: {
          hasTag: true,
          tagText: "Updated",
        },
      },
      {
        to: "/journeys",
        label: "Journey Paths",
      },
      {
        to: "/reports",
        label: "Custom Reports",
      },
      {
        to: "/initiator-rating",
        label: "Initiator Rating",
      },
      {
        to: "/diminishing-returns",
        label: "Diminishing Returns",
      },
    ],
  },
]);
const adminReportItems = computed((): IMainNavGroup[] => [
  {
    navItems: [
      {
        to: "/affiliate-performance",
        label: "Affiliate Performance",
      },
    ],
  },
]);
const customReports = computed((): IMainNavGroup[] => {
  const title = `${getCurrentProgramName.value} Report`;
  const navItems = getCurrentProgramCustomReports.value.map((report) => ({
    label: report.report_name,
    to: `/custom-reports/${report.report_id}`,
  }));
  return [
    {
      title,
      navItems,
    },
  ];
});
const adminManagement = computed((): IMainNavGroup[] => [
  {
    title: "Management",
    navItems: [
      {
        label: "Fixed Spend",
        to: "/account/costs/fixed",
      },
      {
        label: "Variable Spend",
        to: "/account/costs/variable",
      },
      { to: "/segment-groups", label: "Segment Management" },
    ],
  },
]);
const noAdminManagement = computed((): IMainNavGroup[] => [
  {
    navItems: [
      {
        label: "Account Connections",
        to: "/account/connections",
      },
      {
        label: "Seasonality Configuration",
        to: "/seasonality-configuration",
      },
      {
        label: "Switch Account",
        config: {
          hasDropdown: true,
          hasIcon: true,
        },
        navChildren: [
          {
            isLink: false,
            getAvailablePrograms: getAvailablePrograms.value,
          },
        ],
      },
    ],
  },
]);
const adminSection = computed((): IMainNavGroup[] => [
  {
    title: "Admin",
    navItems: [
      {
        label: "Traffic Classification",
        to: "/admin/classification",
      },
      {
        label: "Logout",
        to: "/logout",
      },
    ],
  },
]);

const { beforeEach } = useRouter();

//Watch for the activeProgram change from the Hook.
watch(activeProgram, (val) => {
  setProgram(val, props.close);
});
//Close sidebar when route changes
beforeEach(() => {
  props.close();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuItems), (item, i) => {
        return (_openBlock(), _createBlock(MainNavigationList, {
          key: i,
          title: item.title,
          "nav-items": item.navItems
        }, null, 8, ["title", "nav-items"]))
      }), 128)),
      (_unref(getUserAdmin))
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(adminReportItems), (item, i) => {
            return (_openBlock(), _createBlock(MainNavigationList, {
              key: i,
              "nav-items": item.navItems
            }, null, 8, ["nav-items"]))
          }), 128))
        : _createCommentVNode("", true),
      (_unref(getCurrentProgramCustomReports).length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(customReports), (report, i) => {
            return (_openBlock(), _createBlock(MainNavigationList, {
              key: i,
              title: report.title,
              "nav-items": report.navItems
            }, null, 8, ["title", "nav-items"]))
          }), 128))
        : _createCommentVNode("", true),
      (_unref(getUserAdmin))
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_unref(adminManagement), (item, i) => {
            return (_openBlock(), _createBlock(MainNavigationList, {
              key: i,
              title: item.title,
              "nav-items": item.navItems
            }, null, 8, ["title", "nav-items"]))
          }), 128))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(noAdminManagement), (item, i) => {
        return (_openBlock(), _createBlock(MainNavigationList, {
          key: i,
          "nav-items": item.navItems,
          "active-program": _unref(getCurrentProgram)
        }, null, 8, ["nav-items", "active-program"]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(adminSection), (item, i) => {
        return (_openBlock(), _createBlock(MainNavigationList, {
          key: i,
          title: item.title,
          "nav-items": item.navItems
        }, null, 8, ["title", "nav-items"]))
      }), 128))
    ])
  ]))
}
}

})